import React from "react";
import { MainContainer } from "./styles";
import AuditDocument from "../../AuditNotesActions/AuditDocument/AuditDocument";
import { TravelExpenseRef } from "../../../../../../../../../models/travel-expenses";
import { EmployeeRef } from "../../../../../../../../../models/employees";
import AuditNotes from "../../AuditNotesActions/AuditNotes/AuditNotes";
import ReadOnlyReceiptDetails from "../../ReceiptComponents/ReadOnlyReceiptDetails/ReadOnlyReceiptDetails";
import { DocumentDTO } from "../../../../../../../../../models/documents/document-dto";
import { TravelExpenseAuditNotesDTO } from "../../../../../../../../../models/travel-expense-audit-notes";

interface Props {
  travelExpense: TravelExpenseRef;
  employee: EmployeeRef;
  handleNotifyParent: (document: DocumentDTO | null) => void;
  defaultTravelExpense: TravelExpenseRef;
  disabledAuditActions: boolean;
  updateLastAuditNote: (auditNote: TravelExpenseAuditNotesDTO) => void;
  hideAuditNotes: boolean;
  isManagedByLink?: boolean;
}

const ReceiptReadOnlyView = ({
  travelExpense,
  employee,
  handleNotifyParent,
  defaultTravelExpense,
  disabledAuditActions,
  updateLastAuditNote,
  hideAuditNotes,
  isManagedByLink,
}: Props) => {
  return (
    <MainContainer>
      <ReadOnlyReceiptDetails travelExpense={travelExpense} />

      <>
        <>
          {/* <AuditDocument
            travelExpense={travelExpense}
            document={travelExpense.auditDocument}
            employee={employee}
            handleNotifyParent={handleNotifyParent}
            readOnly={disabledAuditActions || !defaultTravelExpense.auditNotes.length}
          /> */}

          <AuditNotes
            employee={employee}
            travelExpense={defaultTravelExpense}
            legalEntity={employee?.legalEntity ?? defaultTravelExpense?.legalEntity}
            readOnly={disabledAuditActions || !defaultTravelExpense.auditNotes.length}
            updateLastAuditNote={updateLastAuditNote}
            isManagedByLink={isManagedByLink}
          />
        </>
      </>
    </MainContainer>
  );
};

export default ReceiptReadOnlyView;
